<div class="management-dialog-part">
	<div class="row">
		<div class="col-md-6">
			<div class="management-dialog-container">
				<acc-application-change-language-part />
			</div>

			<div class="mt-5">
				<acc-application-application-seat-part />
			</div>
		</div>
		<div class="col-md-6">
			<div>
				<reset-participant-videos-part />
			</div>
		</div>
	</div>
</div>